export class DashboardState {
  /**
   * @var {boolean}
   */
  needsReload = false;

  /**
   * @var {boolean}
   */
  filtersNeedsReload = false;

  /**
   * @var {boolean}
   */
  isInitializingDashboard = false;

  /**
   * Have the filters been loaded from the backend yet
   * @var {boolean}
   */
  filtersInitialized = false;

  /**
   * @var {Array.<DashboardFilterOption>}
   */
  filterOptions = null;

  /**
   * @var {Array.<DashboardFilterOption>}
   */
  activeDashboardFilterOptions = null;

  /**
   * @var {DashboardFilters}
   */
  filters = null;

  /**
   * @var {?Dashboard}
   */
  dashboard = null;

  /**
   * If widget is resizing
   */
  isResizingWidgetId;

  /**
   * @var {Number}
   */
  currentLayoutId = null;

  /**
   * @type {Number|null}
   */
  layoutLoadStartEpochMs = null;

  /**
   * @type {Number|null}
   */
  layoutLoadStartPerfMs = null;

  /**
   * @type {Number|null}
   */
  layoutLoadStartLayoutId = null;

  /**
   * @var {WidgetHighlightOption[]}
   */
  highlightedWidgetsOptions = [];

  /**
   * @type {boolean}
   */
  exportAllLayouts = true;

  /**
   * @type {Array}
   */
  hydratingLayouts = [];

  /**
   * @type {Array}
   */
  hydratedLayouts = [];

  /**
   * @type {String}
   */
  mapBoxAccessToken = null;

  /**
   * @type {boolean}
   */
  showBenchmarkMessage = false;
}
